import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import i18n from './lang'; // internationalization
import '@/router/module/permissions.js'; // 路由权限
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
// import "@/assets/theme/index.css"; //换肤样式
import '@/assets/style/index.scss'; //全局公共样式
import '@/assets/style/loading.scss'; // loading 样式
import Fragment from 'vue-fragment'; // 可产生虚拟根节点
import ElTableEdit from 'el-table-edit';
import vClickOutside from 'v-click-outside';
import request from '@/utils/axios';
// 引入其他组件
import Vab from '@/utils/vab'; // 自定义插件
import Pagination from '@/pages/Pagination'; // 自定义插件-分页
import VueClipboard from 'vue-clipboard2';
import VabIcon from 'vab-icon'; // icon
// 图片放大
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
Vue.use(Viewer);
Viewer.setDefaults({
	Options: {
		inline: true,
		button: true,
		navbar: true,
		title: true,
		toolbar: true,
		tooltip: true,
		movable: true,
		zoomable: true,
		rotatable: true,
		scalable: true,
		transition: true,
		fullscreen: true,
		keyboard: true,
		url: 'data-source'
	}
});
// 图片放大 -- END
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Fragment.Plugin);
Vue.use(ElTableEdit);
Vue.use(vClickOutside); // 在元素外部点击时触发
// qita其他组件
Vue.use(Vab); // 全局组件
Vue.use(VueClipboard);
Vue.component('pagination', Pagination); // 自定义插件-分页
Vue.component('VabIcon', VabIcon);

// 多语言
Vue.use(ElementUI, {
	i18n: (key, value) => i18n.t(key, value)
});
// 设置element组件默认值
Vue.prototype.$ELEMENT = { size: 'medium', zIndex: 3000 };
ElementUI.Input.props.clearable = {
	type: Boolean,
	default: true
};
ElementUI.Select.props.clearable = {
	type: Boolean,
	default: true
};
Vue.prototype.request = request;

new Vue({
	router,
	store,
	i18n,
	render: (h) => h(App)
}).$mount('#app');
